
<template>
  <v-layout>
    <v-flex>
      <v-text-field
        v-model="likePatternName"
        clearable
        @keyup.enter="getSimilarItems"
        label="Like para el nombre"
        prepend-icon="check"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "matching"
);

export default {
  computed: {
    ...mapState(["similarItemsFilters"]),
    likePatternName: {
      get() {
        return this.similarItemsFilters.likePatternName;
      },
      set(pattern) {
        this.setSimilarItemsFiltersLikePatternName(pattern);
      }
    }
  },
  methods: {
    ...mapActions(["getSimilarItems"]),
    ...mapMutations(["setSimilarItemsFiltersLikePatternName"])
  }
};
</script>
